module.exports = __webpack_public_path__ + "static/media/arrow-up.54258109.svg";